// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import RentersInsuranceInput from '../renters-insurance';

const RentersInsuranceInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <RentersInsuranceInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default RentersInsuranceInputWithAnalytics;
